/**
 * /app/trusts/$id/portfolios — JSE / listed-holdings portfolio (route shell).
 *
 * Screen impl in `./portfolios-screen.tsx`, lazy-loaded via `lazyRouteComponent`.
 * A deep trust sub-tab (holdings table + add-holding modal + asset-class
 * breakdown), not a first-paint route, so the body leaves the entry bundle
 * (200 kB gzip budget). Same shell+screen pattern as the sibling `./documents.tsx`
 * / `./audit.tsx` tabs. The committed routeTree.gen.ts imports only `Route` from
 * here, so no plugin regen is needed.
 *
 * PFO-01 (2026-08-27): `?add=listed` lands with the listed-holding form already
 * open. The sibling shells `./properties.tsx` and `./companies.tsx` take
 * `?add=true` instead, because each of those has exactly one add form while
 * this screen is the front door to all three types.
 */

import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

/** Only the one value means anything here, and anything else yields `{}` — a
 *  hand-typed query can never throw the route. */
function validatePortfoliosSearch(
  search: Record<string, unknown>,
): { add?: 'listed' } {
  return search['add'] === 'listed' ? { add: 'listed' } : {};
}

export const Route = createFileRoute('/app/trusts/$id/portfolios')({
  component: lazyRouteComponent(() => import('./portfolios-screen'), 'PortfoliosScreen'),
  validateSearch: validatePortfoliosSearch,
});
